import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";

import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import InputSelect from "../common/InputSelect";
import "./CloneProfileLimit.css";

function CloneProfileLimit({
  className = "",
  classNameButton = "",
  title,
  buttonText,
  params: { Id },
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const changesPayload = useMemo(
    () => ({
      Id,
    }),
    [Id]
  );
  const [bookID, setBookID] = useState(0);
  const [newName, setNewName] = useState("");
  const [books, setBooks] = useState();

  const [open, setOpen] = useState(null);
  const handleOpenDialog = (state) => setOpen(state);

  /**
   * GET FIELDS
   */
  const handleChange = (event, key, value) => {
    setNewName({
      ...newName,
      [key]: event ? event.target.value : value,
    });
  };

  function changeBookID(value) {
    setBookID(value);
  }

  const handleSave = () => {
    CloneProfileLimit();
  };

  const CloneProfileLimit = () => {
    let CloneRequest = {
      IdProfileLimits: changesPayload.Id,
      NewName: newName.NewName,
      IdUser: userInfo.userId,
      IdBook: bookID,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL + "/Profile/PlayerProfileLimits_Clone",
      //url: 'https://localhost:44337/api/Agent/Agent_Update',
      data: CloneRequest,
    }).then((response) => {
      if (response.data === "-1") {
        alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  };

  /**
   * Initial load
   */
  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Player/GetBooks";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let bookInfo = data.map((v) => {
          v.IdBook = v.IdBook;
          v.Description = v.Description;
          return v;
        });
        setBooks(bookInfo);
      });
  }, [setBooks]);

  return (
    <>
      <Button
        className={`${classNameButton}`}
        variant="contained"
        onClick={() => handleOpenDialog(true)}
      >
        {buttonText ? buttonText : "Last Changes"}
      </Button>
      <Dialog open={open} fullWidth>
        <DialogContent>
          <div
            id="main-div"
            className={`${className} !h-max w-full flex-grow-0`}
          >
            <Paper>
              <h2>{title}</h2>

              <div>
                <div>
                  <h3>Clone Profile Limits</h3>
                  <Table>
                    <TableRow>
                      <TableCell>
                        <TextField
                          variant="outlined"
                          id="newName"
                          label="New Name"
                          type="text"
                          onChange={(event) => handleChange(event, "NewName")}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <br></br>
                        <InputSelect
                          variant="outlined"
                          size="small"
                          label="Book"
                          name="name"
                          data={books}
                          placeholder="Book"
                          setSelectValue={changeBookID}
                          startValue={bookID}
                          style="width: 100%;"
                        />
                      </TableCell>
                    </TableRow>
                  </Table>
                </div>
              </div>
            </Paper>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
          <Button variant="contained" onClick={() => handleOpenDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CloneProfileLimit;
